/*
 * @Author: shiguang
 * @Date: 2023-04-25 10:46:45
 * @LastEditors: tianzhitong laotianwy@163.com
 * @LastEditTime: 2023-08-29 09:19:00
 * @Description: shiguang
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n/i18n';
import './index.css';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(<App />);
